import { SvgIcon } from '@mui/material';

export default function (props) {
    return (
        <SvgIcon {...props}>
            <path d="m 20.762 8.581 v 8.509 h -16.38 v -8.509 h 16.38 m 1.287 -2.34 h -2.457 c -3.51 -2.34 -10.53 -2.34 -14.04 0 h -2.457 c -0.585 0 -1.053 0.468 -1.053 1.053 v 13.104 c 0 0.468 0.468 1.053 1.053 1.053 h 18.954 c 0.468 0 1.053 -0.585 1.053 -1.053 v -13.104 c 0 -0.585 -0.585 -1.053 -1.053 -1.053 z M 4.373 18.206 h 2.34 v 1.541 h -2.34 z M 9.053 18.206 h 2.34 v 1.541 h -2.34 z M 13.733 18.206 h 2.34 v 1.541 h -2.34 z M 18.413 18.206 h 2.34 v 1.541 h -2.34 z" />
        </SvgIcon>
    );
}